<template>
  <v-dialog v-model="value" persistent max-width="800" scrollable>
    <v-card>
      <v-card-title>
        <span class="primary--text title">เพิ่มสินค้าลงใน PRODUCT BUNDLED</span>
        <v-spacer /><v-btn icon @click="handleCancelManageProductInBundle">
          <v-icon>close</v-icon></v-btn
        >
      </v-card-title>

      <v-layout>
        <v-flex class="px-3 py-2 d-flex align-center">
          <span class="pr-1">หมวดหมู่</span>
          <v-select
            v-model="filter.category"
            :items="categories"
            outline
            hide-details
            single-line
            clearable
            placeholder="หมวดหมู่สินค้าทั้งหมด"
            @change="handleChangeCategory"
            item-value="id"
            item-text="name"
          ></v-select>
        </v-flex>
        <v-flex class="px-3 py-2 d-flex align-center">
          <span class="pr-1"> ค้นหา</span>
          <v-text-field
            class="default-input"
            outline
            name="search"
            v-model="filter.search"
            hide-details
            single-line
            clearable
            append-icon="search"
            @click:clear="filter.search = ''"
            style="max-width: 300px"
            @keydown.enter="onSearch"
            @input="onSearch"
            dense
            placeholder="ชื่อสินค้า/รหัสสินค้า"
            :loading="loading"
          />
        </v-flex>
      </v-layout>
      <v-divider />
      <v-card-text>
        <pagination
          v-model="pageNumber"
          :limit="limit"
          :total="total"
          :key="timestamp"
          @onChange="handleChangePage"
        >
          <v-layout style="align-items: center" class="grey lighten-3">
            <v-flex xs1 class="pa-2">
              <v-checkbox
                primary
                hide-details
                color="primary"
                class="mt-0"
                :input-value="selectAll"
                @change="handleSelectAllProduct"
              ></v-checkbox>
            </v-flex>
            <v-flex xs5 class="pa-2">รายการสินค้า </v-flex>
            <v-flex xs3 class="text-xs-center pa-2">ราคา</v-flex>
            <v-flex xs3 class="text-xs-center pa-2">จำนวนสินค้า</v-flex>
          </v-layout>
          <template v-for="product in masterProducts">
            <v-layout
              :key="`product_${product.id}`"
              @click="handleSelectProduct(product)"
              style="align-items: center"
            >
              <v-flex xs1 class="pa-2">
                <v-checkbox
                  :input-value="selected.some((p) => p.id == product.id)"
                  primary
                  hide-details
                  color="primary"
                  class="mt-0"
                ></v-checkbox>
              </v-flex>
              <v-flex xs5>
                <v-layout align-center>
                  <v-flex shrink class="pa-1">
                    <img
                      :src="
                        product && product.photourl.length
                          ? product.photourl[0]
                          : '/static/img/assets/_global/default-photo.png'
                      "
                      alt="product"
                      style="width: 50px"
                    />
                  </v-flex>
                  <v-flex class="pa-2">{{ product.name }}</v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs3 class="text-xs-center">{{ product.price || 0 }}</v-flex>
              <v-flex xs3 class="text-xs-center">{{ product.quantity || 0 | numberFormat }}</v-flex>
            </v-layout>
            <v-divider :key="`divider_product_${product.id}`" />
          </template>
        </pagination>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <span class="pr-2"
          >เลือกสินค้าแล้วทั้งหมด {{ selected.length }} ชิ้น (สูงสุด {{ maxProduct }} ชิ้น)</span
        >
        <v-btn outline @click="handleCancelManageProductInBundle">{{ $t('cancel') }}</v-btn>
        <v-btn color="primary" depressed @click="handleSaveManageProductInBundle">{{
          $t('Save')
        }}</v-btn></v-card-actions
      >
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import nestleApi from '@/api/nestle'
import { handleResponse, handleApiError } from '@/api/util'
import Pagination from '@/components/elements/Pagination2.vue'
import moment from 'moment'
import cloneDeep from 'lodash/cloneDeep'
export default {
  props: {
    value: {},
    products: {
      default: []
    },
    bundle: {
      default: undefined
    }
  },
  components: {
    Pagination
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      categories: 'getCategories',
      loadingCategory: 'getLoadingCategory'
    })
  },
  data() {
    return {
      pageNumber: 1,
      pagination: {},
      loading: true,
      filter: {
        category: null,
        search: null
      },
      searchTimeout: null,
      data: [],
      total: 0,
      maxProduct: 100,
      selected: [],
      bundleProductHeaders: [
        { text: 'รายการสินค้า', value: 'name' },
        { text: 'ราคา', value: 'price', align: 'center' },
        { text: 'จำนวนสินค้า', value: 'quantity', align: 'center' }
      ],
      masterProducts: [],
      limit: 10,
      offset: 0,
      selectAll: false,
      timestamp: moment().format('x')
    }
  },
  async mounted() {
    if (this.products) {
      this.selected = cloneDeep(this.products)
    }
    await this.handleGetData()
  },
  methods: {
    handleSelectAllProduct(val) {
      this.selectAll = val
      const productid = this.masterProducts
      if (val) {
        productid.forEach((product) => {
          if (!this.selected.some((s) => s.id == product.id)) {
            this.selected.push(product)
          }
        })
      } else {
        this.selected = this.selected.filter((s) => !productid.some((p) => p.id == s.id))
      }
    },
    handleSelectProduct(product) {
      if (this.selected.some((p) => product.id == p.id)) {
        this.selected = this.selected.filter((p) => p.id != product.id)
      } else {
        this.selected.push(product)
      }
      this.selectAll =
        this.masterProducts.length &&
        this.masterProducts.filter((product) => this.selected.some((s) => s.id == product.id))
          .length == this.masterProducts.length
    },
    async handleChangePage(val) {
      const { offset } = val
      this.offset = offset
      this.pageNumber = 1
      this.timestamp = moment().format('x')
      await this.handleGetData()
    },
    async handleChangeCategory() {
      this.offset = 0
      this.pageNumber = 1
      this.timestamp = moment().format('x')
      await this.handleGetData()
    },
    async handleGetData(isLoading = true) {
      if (isLoading) {
        this.loading = true
      }
      const { result, total } = await this.getAvailableProducts()
      this.masterProducts = result
      this.total = total
      this.selectAll =
        this.masterProducts.length &&
        this.masterProducts.filter((product) => this.selected.includes(product.id)).length ==
          this.masterProducts.length
      if (isLoading) {
        this.loading = false
      }
    },
    async getAvailableProducts() {
      try {
        const response = await nestleApi.getAvailableProducts({
          data: {
            search: this.filter.search || undefined,
            categoryid: this.filter.category || undefined, // optional
            limit: this.limit,
            offset: this.offset,
            pageid: this.selectedBot.pageid,
            product_bundle_id: this.bundle ? this.bundle.id : undefined
          }
        })

        await handleResponse(response)
        const products = response.data.products.map((product) => {
          const photourl = product.photourl ? product.photourl.split(';;') : []
          return {
            ...product,
            photourl
          }
        })
        return {
          result: products,
          total: response.data.total_products ? parseInt(response.data.total_products) : 0
        }
      } catch (error) {
        await handleApiError(error)
      }

      return {
        result: [],
        total: 0
      }
    },
    handleCancelManageProductInBundle() {
      this.$emit('input', false)
    },
    handleSaveManageProductInBundle() {
      this.$emit('handleSaveManageProductInBundle', this.selected)
      this.$emit('input', false)
    },
    onSearch() {
      const vm = this
      if (vm.searchTimeout) {
        clearTimeout(vm.searchTimeout)
      }
      if (vm.loading) return false
      vm.searchTimeout = setTimeout(async () => {
        vm.loading = true
        try {
          vm.offset = 0
          vm.pageNumber = 1
          vm.timestamp = moment().format('x')
          await vm.handleGetData(false)
        } catch (error) {
          console.error(error)
        }
        vm.loading = false
        vm.searchTimeout = null
      }, 1000)
    }
  },
  watch: {
    pagination: {
      async handler() {
        await this.handleGetData()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/Bundles/ManageProductInBundle.vue